import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
	selector: 'formly-postal-code-input',
	template: `
		<mat-form-field appearance="outline" style="width: 100%">
			<mat-label>{{ props.label }}</mat-label>
			<input
				matInput
				[formControl]="formControl"
				[formlyAttributes]="field"
				[required]="props.required"
				mask="S0S 0S0"
				[placeholder]="props.placeholder || 'S0S 0S0'"
			/>
			<mat-error *ngIf="formControl.invalid && formControl.touched">
				<formly-validation-message [field]="field"></formly-validation-message>
			</mat-error>
		</mat-form-field>
	`,
})
export class PostalCodeInputType extends FieldType<FieldTypeConfig> {}
